var exports = {
  "c": "sectionIntro__B0x-dP",
};

module.exports = exports;
